import React, { useRef, memo, useState, useCallback } from 'react';
import { Loader } from 'js/components/common/Loader';
import buildClassName from 'js/utils/classNameBuilder.util';
import { Pagination } from 'js/components/common/Pagination';

import { TableData } from '../TableData';
import { TABLE_VIEW } from '../../constants';
import { TableSummary } from '../TableSummary';
import { TableLoadMore } from '../TableLoadMore';
import { TableContentFragment } from '../TableContentFragment';

import style from './TableBody.scss';

export const TableBody = memo((props) => {
    const tableBodyRef = useRef();
    const {
        loadMore,
        tableData,
        isLoading,
        classNames,
        emptyTitle,
        pagination,
        tableSummary,
        tableRowView,
        summaryRowView,
        onAccordionExpand,
        onAccordionCollapse,
        beforeTableDataContent
    } = props;
    const [focusIndex, setFocusIndex] = useState(null);
    const rowsLength = tableRowView === TABLE_VIEW.TABLE
        ? tableData?.tableView?.rows?.length : tableData?.accordionView?.rows?.length;

    const onLoadMoreClick = useCallback((event) => {
        setFocusIndex(rowsLength);

        loadMore?.onClick(event);
    }, [loadMore, rowsLength]);
    const emptyData = !tableData?.tableView?.rows?.length && !tableData?.accordionView?.rows?.length;

    if (isLoading) {
        return (
            <div className={buildClassName(['tableBodyInfo'], style, classNames)}>
                <Loader />
            </div>
        );
    }

    return (
        <div ref={tableBodyRef} className={buildClassName(['tableBodyContainer'], style, classNames)}>
            {tableSummary
                ? (
                    <TableSummary
                        data={tableSummary}
                        classNames={classNames}
                        summaryRowView={summaryRowView}
                    />
                ) : null
            }
            {beforeTableDataContent
                ? <TableContentFragment id={0} content={beforeTableDataContent} />
                : null
            }
            {!emptyData
                ? <TableData
                    data={tableData}
                    classNames={classNames}
                    focusIndex={focusIndex}
                    tableRowView={tableRowView}
                    onAccordionExpand={onAccordionExpand}
                    onAccordionCollapse={onAccordionCollapse}
                />
                : null
            }
            {emptyTitle && emptyData
                ? (
                    <div className={`${buildClassName(['tableBodyInfo'], style, classNames)} ${buildClassName(['tableBodyEmpty'], style, classNames)}`}>
                        {emptyTitle}
                    </div>
                ) : null
            }
            {loadMore
                ? <TableLoadMore
                    title={loadMore.title}
                    classNames={classNames}
                    onClick={onLoadMoreClick}
                    disabled={loadMore.disabled}
                />
                : null
            }
            {pagination
                ? <Pagination {...pagination} componentRef={tableBodyRef} />
                : null
            }
        </div>
    );
});
